/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

const languages = [
	'ar', 'bg', 'bn', 'ca', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'he', 'hi', 'hu', 'id', 'it', 'ja', 'ko',
	'lt', 'lv', 'ms', 'nl', 'no', 'pl', 'pt', 'pt-br', 'ro', 'ru', 'sk', 'sr', 'sv', 'th', 'tr', 'uk', 'vi', 'zh', 'zh-cn'
] as const;

export type EditorLanguage = typeof languages[ number ];

type Language = {
	code: EditorLanguage;
	displayName: string;
};

export const defaultLanguage: EditorLanguage = 'en';

export function getLanguages(): Array<Language> {
	const languageNameConverter = new Intl.DisplayNames( 'en', { type: 'language' } );

	return languages
		.map( ( code: EditorLanguage ) => {
			const displayName = languageNameConverter.of( code )!;

			return { code, displayName };
		} )
		.sort( ( a: Language, b: Language ) => a.displayName.localeCompare( b.displayName ) );
}
